import React from "react";

export const TgSubscribe = (
    {
        title = "Telegram-уведомления",
        description = "Подпишись на наш Telegramm-канал<br/>чтобы быть в курсе всех событий нашего интернет-магазина",
        items = [
            '+ Уведомления о поступлении товара',
            '+ Уведомления о новых заказах',
            '+ Напоминанание о доставке, при ожидании более 3-х дней',
        ],
        linkTg = 'https://t.me/KotofeyStoreMassNotifyBot',
        buttonLabel = "Подписаться",
        img = "/images/courses.jpg",
    }
) => {

    return <div className="TgSubscribe">
        <div className="TgSubscribe-frame">
            <div className="TgSubscribe-title">{title}</div>
            <div className="TgSubscribe-descripton" dangerouslySetInnerHTML={{__html: description}}/>
            <a href={linkTg} target="_blank" className="TgSubscribe-link">{buttonLabel}</a>
        </div>
        <div className="TgSubscribe-frame-pluses">
            {items.map((element, index) => {
                return <div className="TgSubscribe-frame-pluses-item" key={index}>{element}</div>
            })}
        </div>
        <img className="TgSubscribe-image" src={img}/>
    </div>
};